export default "__VITE_ASSET__CSn8g20u__"